import * as React from "react";
import styles from "./StepperComponent.module.scss";
import classnames from "classnames";

function Step({ text, current, done, onClick }) {
    return (
        <div onClick={onClick} className={classnames(styles["step"], current && styles["step-current"], done && styles["step-done"], onClick && styles["step-clickable"])}>
            <div className={styles["text"]}>{text}</div>
            <div className={classnames(styles["line"])} />
        </div>
    );
}

export function StepperComponent(props) {
    // The flow supplies the steps it actually visits, so a step it never reaches is not
    // rendered at all rather than rendered and inert.
    const { currentStep, steps, onClick, getLocaleText } = props;
    if (!currentStep || !steps?.length) {
        return null;
    }
    const maxSteps = steps.length;
    return (
        <div className={styles["wrapper"]}>
            {steps.map((step, index) => {
                const stepNumber = index + 1;
                const isLastStep = stepNumber === maxSteps;
                // The last step is only reachable from the one before it, where clicking it
                // means "continue"; the others can also be gone back to.
                const clickable = isLastStep ? currentStep === maxSteps - 1 : currentStep !== stepNumber;
                return <Step key={step} text={getLocaleText(step)} onClick={clickable ? () => onClick(stepNumber) : undefined} current={currentStep === stepNumber} done={currentStep > stepNumber} />;
            })}
            <div
                style={{
                    width: `calc(${Math.min(currentStep / maxSteps, 1) * 100}% - 2px`,
                }}
                className={styles["colored-line"]}
            />
        </div>
    );
}
